// Tracks a "checkout in progress" marker across the full-page redirect to
// Stripe and back, so the landing page can show a brief loading state while
// it waits for the subscription webhook to catch up (it typically lands
// 2-3s after Stripe redirects the browser back).
const STORAGE_KEY = 'cuelist_pending_plan_update';
const MARKER_MAX_AGE_MS = 5 * 60 * 1000;

function stashPendingPlanUpdate(user) {
    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
            prevActivePay: !!(user && user.active_pay),
            prevSubscriptionId: (user && user.subscription_id) || '',
            prevPriceId: (user && user.price_id) || '',
            ts: Date.now()
        }));
    } catch (_e) {
        // sessionStorage unavailable (private mode, etc) — loader just won't show
    }
}

function clearPendingPlanUpdate() {
    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch (_e) {
        // ignore
    }
}

function readPendingPlanUpdate() {
    let raw;
    try {
        raw = sessionStorage.getItem(STORAGE_KEY);
    } catch (_e) {
        return null;
    }
    if (!raw) return null;
    let marker;
    try {
        marker = JSON.parse(raw);
    } catch (_e) {
        clearPendingPlanUpdate();
        return null;
    }
    if (!marker || !marker.ts || Date.now() - marker.ts > MARKER_MAX_AGE_MS) {
        clearPendingPlanUpdate();
        return null;
    }
    return marker;
}

export { stashPendingPlanUpdate, readPendingPlanUpdate, clearPendingPlanUpdate };


// WEBPACK FOOTER //
// ./src/lib/pending-plan-update.js